// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"8210c91e","453":"878b84f3","782":"fbe736ba","846":"dad8fd64"}[chunkId] + ".chunk.js";
};